/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { TextField, Button } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/organize/movelivecontent/movelivecontent_styles';



/* ========== ~~~~~~~~~~ EMBED ORGANZIE : CUSTOM TOGGLE ~~~~~~~~~~ ========== */
class MoveLiveContent extends Component {
    constructor(props){
        super(props);

        this.state = {
          start: 1,
          end: 2
        };
    }

    handleClick = () => {
        if(this.state.start === this.state.end){
            return null;
        }
        this.props.handleMove(this.state.start - 1, this.state.end - 1);
    };

    changeStart = position => {
        let newPosition = this.controlPosition(position);
        this.setState({start: newPosition});
        this.props.setStartCard(newPosition - 1);
    };

    changeEnd = position => {
        let newPosition = this.controlPosition(position);
        this.setState({end: newPosition})
    };

    controlPosition = position => {
        if(position > this.props.numberOfLiveContents){
            return this.props.numberOfLiveContents
        }
        return position;
    };

    disableMove = () => (this.state.start < 1 || this.state.end < 1) || this.state.start == this.state.end;

    render() {
        return (
            <div className={`movelivecontent ${this.props.classes.movelivecontent}`}>
                <div className={'positions'}>
                    <span> Move card: </span>
                    <TextField
                        type={'number'}
                        value={this.state.start}
                        handleChange={e => this.changeStart(e.target.value)}
                    />
                    <span> to position: </span>
                    <TextField
                        type={'number'}
                        value={this.state.end}
                        handleChange={e => this.changeEnd(e.target.value)}
                        handleFocus={() => this.props.setStartCard((this.state.start - 1))}
                    />
                </div>
                <Button
                    text={'Move'}
                    type={'action'}
                    action={this.handleClick}
                    variant={'primary'}
                    operation={'load'}
                    disabled={this.disableMove()}
                    processing={this.props.moving}
                    removeLoaderIcon={true}
                />
                {/*<Tip*/}
                {/*    space={'left'}*/}
                {/*    content={<p> Choose position you want to move live content to </p>}*/}
                {/*/>*/}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(MoveLiveContent);
